const REVIEWS = [
  {
    name: "Sarah & Tom",
    origin: "Dublin",
    date: "April 2025",
    rating: 5,
    text: "We couldn't have asked for a more special long weekend. Waking up to the sound of the water, coffee on the rear deck as the mist lifted over Lough Ree — it genuinely felt miles from the world. Dru was brilliant from first message to check-out. We've already told everyone we know.",
    highlight: "Woke up to the water every morning",
  },
  {
    name: "James O'Brien",
    origin: "Galway",
    date: "May 2025",
    rating: 5,
    text: "Booked this for our anniversary and it exceeded everything we hoped for. The houseboat is beautifully fitted out — warm, cosy, with everything you need and nothing you don't. The two decks are a real treat. We walked to The Chalets for dinner one evening and it was perfect. Already planning a return trip.",
    highlight: "Perfect for a special occasion",
  },
  {
    name: "Claire Murphy",
    origin: "Cork",
    date: "June 2025",
    rating: 5,
    text: "Genuinely one of the most unique places I've ever stayed. I'd been sceptical about a houseboat but it completely won me over. It's incredibly well insulated and quiet — I slept better than I have in months. The self check-in was seamless and Dru replied to every question within the hour. Ten out of ten.",
    highlight: "Unique, peaceful and beautifully done",
  },
];

function Stars({ count = 5 }) {
  return (
    <div className="flex gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <svg key={i} width="12" height="12" viewBox="0 0 12 12" fill="currentColor" className="text-[#C8A96E]">
          <path d="M6 0.5l1.545 3.13 3.455.502-2.5 2.436.59 3.44L6 8.385l-3.09 1.623.59-3.44L1 4.132l3.455-.502L6 .5z" />
        </svg>
      ))}
    </div>
  );
}

export default function ReviewsSection() {
  return (
    <section className="bg-[#F5F3EE] py-24 sm:py-32">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">

        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-16">
          <div>
            <p className="eyebrow mb-4">Guest Reviews</p>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light text-[#1C1C1A] tracking-tight leading-tight">
              Straight from<br />
              <em className="italic">our guests.</em>
            </h2>
          </div>
          <div className="flex items-center gap-3 shrink-0">
            <div>
              <p className="font-serif text-5xl font-light text-[#1C1C1A] leading-none">5.0</p>
              <Stars />
              <p className="text-[0.65rem] text-[#6B6B65] uppercase tracking-[0.15em] mt-1.5">Average rating</p>
            </div>
          </div>
        </div>

        {/* Review cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {REVIEWS.map((r) => (
            <div key={r.name} className="bg-[#FAFAF8] p-8 sm:p-10 flex flex-col">
              {/* Stars + date */}
              <div className="flex items-center justify-between mb-6">
                <Stars count={r.rating} />
                <span className="text-[0.65rem] text-[#6B6B65] uppercase tracking-[0.14em]">{r.date}</span>
              </div>

              {/* Highlight quote */}
              <p className="font-serif text-xl font-light text-[#1C1C1A] leading-snug mb-4">
                "{r.highlight}"
              </p>

              {/* Full text */}
              <p className="text-sm text-[#6B6B65] leading-relaxed font-light flex-1">
                {r.text}
              </p>

              {/* Reviewer */}
              <div className="mt-8 pt-6 border-t border-[#1C1C1A]/8 flex items-center gap-3">
                {/* Initials avatar */}
                <div className="w-8 h-8 rounded-full bg-[#1C1C1A] flex items-center justify-center shrink-0">
                  <span className="text-white text-[0.6rem] font-medium tracking-wide">
                    {r.name.split(" ").map(n => n[0]).join("").slice(0, 2)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-medium text-[#1C1C1A]">{r.name}</p>
                  <p className="text-[0.65rem] text-[#6B6B65] uppercase tracking-[0.12em]">{r.origin}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Disclaimer */}
        <p className="mt-8 text-[0.65rem] text-[#6B6B65]/70 text-center">
          Representative reviews. As a new listing we're actively collecting verified reviews — check Airbnb for the latest.
        </p>
      </div>
    </section>
  );
}
